import { extend } from 'flarum/common/extend';
import TerminalPost from 'flarum/forum/components/TerminalPost';
app.initializers.add('val-ui-terminal-post-group-color', () => {
  extend(TerminalPost.prototype, 'view', function (vnode) {
    const discussion = this.attrs.discussion;
    if (!discussion || !vnode) {
      return;
    }
    const lastPost = !!this.attrs.lastPost && typeof discussion.replyCount === 'function' && discussion.replyCount();
    const color = discussion.attribute(lastPost ? 'valLastPostedUserColor' : 'valStartedUserColor');
    if (typeof color !== 'string' || color.trim() === '') {
      return;
    }
    vnode.attrs = vnode.attrs || {};
    vnode.attrs.className = (vnode.attrs.className || '') + ' val-terminal-post-group-colored';
    vnode.attrs.style = Object.assign({}, vnode.attrs.style || {}, {
      '--val-terminal-post-user-color': color
    });
  });
});